import { LineUp, Stat } from '@/models/match-live-data';
import React from 'react';
import { H3, H5, H6, Label } from './text';

const calculatePercentage = (homeValue: number, awayValue: number) => {
	return (homeValue / (homeValue + awayValue)) * 100;
};

const statTypeMappings: { [key: string]: string } = {
	totalScoringAtt: 'Schoten',
	ontargetScoringAtt: 'Schoten op doel',
	totalOffside: 'Buitenspel',
	cornerTaken: 'Corners',
	fkFoulLost: 'Overtredingen',
	possessionPercentage: 'Balbezit',
};

const combineStats = (lineUp: LineUp[], desiredStatTypes: string[]) => {
	if (!lineUp || lineUp.length < 2) {
		return [];
	}
	const homeStats = lineUp[0]?.stat;
	const awayStats = lineUp[1]?.stat;

	if (!homeStats || !awayStats) {
		return [];
	}

	const combinedStats = desiredStatTypes
		.map((type) => {
			const homeStat = homeStats.find((stat: Stat) => stat.type === type);
			const awayStat = awayStats.find((stat: Stat) => stat.type === type);

			if (homeStat && awayStat) {
				const homeValue = parseFloat(homeStat.value);
				const awayValue = parseFloat(awayStat.value);

				return {
					type,
					readableName: statTypeMappings[type] || type,
					homeValue,
					awayValue,
					percentage: calculatePercentage(homeValue, awayValue),
				};
			}

			return null;
		})
		.filter((stat) => stat !== null);

	return combinedStats;
};

const displayCombinedStats = (combinedStats: any[]) => {
	if (combinedStats.length === 0) {
		return (
			<div className="text-center">
				<H5>Geen statistieken beschikbaar</H5>
			</div>
		);
	}
	return combinedStats.map((stat: any, index) => (
		<div key={index}>
			<H6 className="text-center w-full mb-4">{stat.readableName}</H6>
			<div key={stat.type} className="flex justify-center items-center gap-8 mb-8">
				<div className="flex-none w-8 text-left">
					<Label>{stat.homeValue}</Label>
				</div>

				<div className="flex-1">
					<ProgressBar percentage={stat.percentage} />
				</div>
				<div className="flex-none w-8 text-right">
					<Label>{stat.awayValue}</Label>
				</div>
			</div>
		</div>
	));
};

const MatchStats = ({ lineUp, desiredStatTypes }: { lineUp: LineUp[]; desiredStatTypes: string[] }) => {
	if (!lineUp) {
		return (
			<div className="text-center">
				<H3 className="text-center py-6">Geen statistieken beschikbaar</H3>
			</div>
		);
	}
	const combinedStats = combineStats(lineUp, desiredStatTypes);

	return <div>{displayCombinedStats(combinedStats)}</div>;
};

export default MatchStats;

export function ProgressBar({ percentage }: { percentage: number }) {
	return (
		<div>
			<h4 className="sr-only">Wedstrijd statistieken</h4>
			<div aria-hidden="true" className="">
				<div className="overflow-hidden rounded-full bg-white">
					<div style={{ width: `${percentage}%` }} className="h-4 rounded-full bg-kkd-blue-dark" />
				</div>
			</div>
		</div>
	);
}
